import type { Messages } from './en';

export const ja: Messages = {
  'nav.clientHub': 'クライアントハブ',
  'nav.menu': 'メニュー',
  'nav.home': 'ホーム',
  'nav.products': '製品',
  'nav.liveCasino': 'ライブカジノ',
  'nav.slots': 'スロット',
  'nav.tableGames': 'テーブルゲーム',
  'nav.library': 'ライブラリ',
  'nav.roadmap': 'ロードマップ',
  'nav.assets': 'アセット',
  'nav.guidelines': 'ガイドライン',
  'nav.account': 'アカウント',
  'nav.signOut': 'ログアウト',
  'nav.categoriesAria': 'ゲームカテゴリー',
  'nav.sectionsAria': 'メインセクション',
  'nav.brandAria': 'RichyPlay クライアントハブ',
  'nav.comingSoon': '近日公開',
  'nav.soon': '近日',

  'lang.label': '言語',
  'lang.select': '言語を選択',

  'category.live': 'ライブ',
  'category.slot': 'スロット',
  'category.instant': 'インスタント',
  'category.table': 'テーブル',

  'status.planned': '計画中',
  'status.in_progress': '進行中',
  'status.shipped': 'リリース済み',
  'status.available': '利用可能',
  'status.coming_soon': '近日公開',
  'status.maintenance': 'メンテナンス中',

  'common.error': '問題が発生しました',
  'common.checkingSession': 'セッションを確認しています…',
  'common.yes': 'はい',
  'common.no': 'いいえ',
  'common.none': 'なし',
  'common.active': '有効',
  'common.inactive': '無効',

  'home.eyebrow': 'オペレーターポータル',
  'home.title': 'クライアントハブ',
  'home.lead':
    'RichyPlay のポートフォリオをご覧ください。デモの起動、ロードマップの確認、ブランドアセットのダウンロードを一つのワークスペースで行えます。',
  'home.enterLibrary': 'ライブラリを開く',
  'home.viewRoadmap': 'ロードマップを見る',
  'home.browse': 'カテゴリーから探す',
  'home.openLibrary': 'ライブラリを開く',

  'library.eyebrow': 'ゲームライブラリ',
  'library.title': 'ポートフォリオ',
  'library.liveTitle': 'ライブカジノポートフォリオ',
  'library.slotTitle': 'スロットポートフォリオ',
  'library.liveLead': 'ライブ商品を選んでください。Blackjack と Roulette は公開中、その他は近日公開です。',
  'liveFamily.roulette': 'Royal Roulette',
  'liveFamily.blackjack': 'Royal Blackjack',
  'liveFamily.autoRoulette': 'Auto Roulette',
  'liveFamily.thunderRoulette': 'Thunder Roulette',
  'liveFamily.infinityBlackjack': 'Infinity Blackjack',
  'liveFamily.baccarat': 'Baccarat',
  'liveFamily.poker': 'Poker',
  'liveFamily.dice': 'Dice',
  'liveFamily.showGames': 'Show Games',
  'library.lead': 'RichyPlay カタログを検索・絞り込みできます。デモは新しいタブで起動します。',
  'library.search': 'ゲームを検索…',
  'library.statusFilterAria': 'ステータスで絞り込む',
  'library.statusAll': 'すべてのステータス',
  'library.loading': 'ゲームを読み込み中…',
  'library.unavailableTitle': 'ライブラリを利用できません',
  'library.unavailableMessage':
    'ゲームライブラリを読み込めませんでした。カタログが一時的に利用できない可能性があります。',
  'library.apiFailedMessage':
    'カタログ API に接続できませんでした。しばらくしてから再試行するか、サポートにお問い合わせください。',
  'library.emptyTitle': 'ゲームが見つかりません',
  'library.emptyMessage': '別のキーワードやカテゴリーでお試しください。',
  'library.viewGame': 'ゲームを見る',

  'game.loading': 'ゲームを読み込み中…',
  'game.notFound': 'ゲームが見つかりません。',
  'game.back': '戻る',
  'game.breadcrumbAria': 'パンくずリスト',
  'game.liveCasino': 'ライブカジノ',
  'game.slots': 'スロット',
  'game.demoFrameTitle': '{title} のデモ',
  'game.startingDemo': 'デモセッションを開始しています…',
  'game.demoNotStarted': 'デモセッションを開始できませんでした。',
  'game.demoBadge': 'デモモード',
  'game.blockedMaintenance': 'このゲームはメンテナンス中です。',
  'game.blockedComingSoon': '近日公開 — デモはまだ公開されていません。',
  'game.blockedNoDemo': 'オペレーターカタログにこのタイトルのデモ版はありません。',
  'game.currency': '通貨',
  'game.language': '言語',
  'game.reloadDemo': 'デモを再読み込み',
  'game.startDemo': 'デモを開始',
  'game.openNewTab': '新しいタブで開く',
  'game.copyLink': 'リンクをコピー',
  'game.copied': 'コピーしました',
  'game.demoFailedTitle': 'デモの起動に失敗しました',
  'game.demoUrlMissing': 'サーバーから起動 URL が返されませんでした。',
  'game.demoFailed': 'デモを起動できませんでした。',
  'game.highlighted': '注目',
  'game.features': 'ゲームの特徴',
  'game.keyFeatures': '主な特徴',
  'liveTable.title': '利用可能なテーブル',
  'liveTable.totalResults': '合計件数:',
  'liveTable.download': 'テーブルデータをダウンロード',
  'liveTable.gameId': 'ゲーム ID',
  'liveTable.tableName': 'テーブル名',
  'liveTable.minLimit': '最低ベット額',
  'liveTable.maxLimit': '最高ベット額',
  'liveTable.hours': '稼働時間 UTC',
  'liveTable.language': '稼働言語',
  'liveTable.releaseDate': 'リリース日',
  'liveTable.location': '所在地',
  'game.betLevels': 'ベットレベル',
  'game.tableRules': 'テーブルルール',
  'game.mathConfig': '数値設定',
  'game.resources': '関連リソース',
  'game.relatedAssets': '関連アセット',
  'game.releaseRoadmap': 'リリースロードマップ',
  'game.integrationGuidelines': '導入ガイドライン',
  'game.information': 'ゲーム情報',
  'game.availableOn': 'Available On',
  'game.operatingLanguage': 'Operating Language',
  'game.uiLanguages': 'UI Languages',
  'game.platformDesktop': 'デスクトップ',
  'game.platformTablet': 'タブレット',
  'game.platformMobile': 'モバイル',
  'game.downloads': 'Downloads',
  'game.mediaPack': 'Media Pack',
  'game.gameData': 'Game Data (PDF)',
  'game.download': 'Download',
  'game.gameDataSoon': 'ゲームデータシートは近日追加されます。',

  'spec.numericId': '数値ID',
  'spec.minBetPerLine': 'ライン最小ベット',
  'spec.minTotalBet': '最小トータルベット',
  'spec.maxTotalBet': '最大トータルベット',
  'spec.maxTotalBetAnte': 'アンテ時の最大トータルベット',
  'spec.reels': 'リール',
  'spec.rows': '行',
  'spec.payType': 'ペイタイプ',
  'spec.payLinesValue': '{count} ライン',
  'spec.symbolPays': 'シンボル配当',
  'spec.betMultiplier': 'ベット倍率',
  'spec.maxMultiplierWin': '最大倍率配当',
  'spec.maxExposure': '最大エクスポージャー',
  'spec.bonusBuyX': 'ボーナス購入 X',
  'spec.anteBetX': 'アンテベット X',
  'spec.rtps': 'RTP',
  'spec.hitFrequency': 'ヒット頻度',
  'spec.oneIn': '{value} 回に1回',
  'spec.hasReplay': 'リプレイ',
  'spec.hasBuySpins': 'スピン購入',
  'spec.hasInstantBonus': 'インスタントボーナス',
  'spec.hasHyperplay': 'ハイパープレイ',
  'spec.hasAnteBet': 'アンテベット',
  'spec.releaseDate': 'リリース日',
  'spec.symbol': 'ゲームシンボル',
  'spec.referenceId': 'リファレンス ID',
  'spec.provider': 'プロバイダー',
  'spec.product': 'プロダクト',
  'spec.gameType': 'ゲームタイプ',
  'spec.category': 'カテゴリー',
  'spec.theme': 'テーマ',
  'spec.technology': 'テクノロジー',
  'spec.rtp': 'RTP',
  'spec.volatility': 'ボラティリティ',
  'spec.maxWin': '最大配当',
  'spec.paylines': 'ペイライン',
  'spec.grid': 'グリッド',
  'spec.bonusFrequency': 'ボーナス頻度',
  'spec.bonusFrequencyValue': '{value} 回に 1 回',
  'spec.jackpot': 'ジャックポット',
  'spec.betRange': 'ベット範囲',
  'spec.defaultBet': 'デフォルトベット',
  'spec.currency': '通貨',
  'spec.languages': '対応言語',
  'spec.demoAvailable': 'デモ提供',
  'spec.tournaments': 'トーナメント',
  'spec.highlighted': '注目',
  'spec.status': 'ステータス',
  'spec.version': 'バージョン',
  'spec.lastUpdated': '最終更新',

  'roadmap.eyebrow': 'プロダクトロードマップ',
  'roadmap.title': '今後の予定',
  'roadmap.lead': 'カテゴリー別に今後のリリースと公開済みタイトルを確認できます。',
  'roadmap.bannerAria': '今後のリリース',
  'roadmap.soonTitle': '近日公開',
  'roadmap.loading': 'ロードマップを読み込み中…',
  'roadmap.error': 'ロードマップの項目を読み込めませんでした。',
  'roadmap.emptyTitle': 'ロードマップ項目はありません',
  'roadmap.emptyMessage': 'このカテゴリーにはまだ公開された項目がありません。',
  'roadmap.itemCount': '{count} 件',
  'roadmap.target': '目標: {date}',
  'roadmap.viewInLibrary': 'ライブラリで見る',

  'upcoming.title': '近日公開',
  'upcoming.playDemo': 'デモをプレイ',
  'upcoming.prev': '前のリリース',
  'upcoming.next': '次のリリース',

  'assets.eyebrow': 'ブランドアセット',
  'assets.title': 'アセットパック',
  'assets.lead':
    'ロゴ、キービジュアル、マーケティング素材をダウンロードできます。利用規則は{link}をご覧ください。',
  'assets.leadLink': 'アセットガイドライン',
  'assets.loading': 'アセットを読み込み中…',
  'assets.error': 'アセットパックを読み込めませんでした。',
  'assets.downloadFailed': 'ダウンロードに失敗しました。',
  'assets.emptyTitle': 'アセットはまだありません',
  'assets.emptyForGame': 'このゲームに関連付けられたアセットパックはありません。',
  'assets.emptyGeneral': '公開されたアセットパックがここに表示されます。',
  'assets.pack': 'パック',
  'assets.updated': '{date} に更新',
  'assets.download': 'ダウンロード',
  'assets.search': 'ゲーム名で検索…',
  'assets.searchEmpty': 'その名前のゲームはありません。',

  'guidelines.eyebrow': 'ドキュメント',
  'guidelines.title': 'ガイドライン',
  'guidelines.lead': '導入メモ、アセットの利用方法、オペレーター向け資料。',
  'guidelines.all': 'すべて',
  'guidelines.integration': '導入',
  'guidelines.assets': 'アセット',
  'guidelines.loading': 'ガイドラインを読み込み中…',
  'guidelines.error': 'ガイドラインを読み込めませんでした。',
  'guidelines.emptyTitle': 'ガイドラインはありません',
  'guidelines.emptyMessage': '公開されたガイドラインがここに表示されます。',
  'guidelines.index': '目次',
  'guidelines.navAria': 'ガイドラインナビゲーション',
  'guidelines.articleLoading': '記事を読み込み中…',
  'guidelines.notFound': 'ガイドラインが見つかりません。',
  'guidelines.notFoundShort': '見つかりません',
  'guidelines.updated': '{date} に更新',
  'guidelines.external': 'コンテンツは外部でホストされています。',
  'guidelines.openDocument': 'ドキュメントを開く',
  'guidelines.typeGuide': 'ガイド',
  'guidelines.typeGuideline': 'ガイドライン',

  'account.eyebrow': 'アカウント',
  'account.title': 'プロフィール',
  'account.email': 'メールアドレス',
  'account.language': '表示言語',
  'account.recentActivity': '最近のアクティビティ',
  'account.loadingActivity': 'アクティビティを読み込み中…',
  'account.activityUnavailable': '現在、最近のアクティビティを表示できません。',
  'account.noActivity': '最近のアクティビティはありません。',

  'event.login': 'ログイン',
  'event.logout': 'ログアウト',
  'event.libraryView': 'ライブラリを表示',
  'event.gameView': 'ゲームを表示',
  'event.demoLaunch': 'デモを起動',
  'event.demoLaunchFailed': 'デモの起動に失敗',
  'event.assetDownload': 'アセットをダウンロード',
  'event.guidelineView': 'ガイドラインを表示',
  'event.roadmapView': 'ロードマップを表示',

  'auth.title': 'クライアントハブ',
  'auth.subtitle': 'オペレーター用の認証情報でログインしてください',
  'auth.email': 'メールアドレス',
  'auth.password': 'パスワード',
  'auth.rememberMe': 'ログイン状態を保持',
  'auth.signIn': 'ログイン',
  'auth.signInFailed': 'ログインに失敗しました',
  'auth.signInError': 'ログインできませんでした。認証情報を確認して再度お試しください。',
  'auth.forgotPassword': 'パスワードをお忘れですか？',
  'auth.inviteOnly': '招待制のアクセスです。RichyPlay の担当者にお問い合わせください。',
  'auth.visitSiteAria': 'richyplay.live へ移動',

  'footer.navAria': 'フッター',
  'footer.tagline': 'RichyPlay のスロットおよびライブカジノ製品向けオペレーターポータル。',
  'footer.rights': 'All rights reserved.',
  'footer.legal': 'ライセンス事業者向けの招待制アクセスです。業務目的のみにご利用ください。',

  'forgot.eyebrow': 'パスワードの再設定',
  'forgot.title': 'パスワードをお忘れの場合',
  'forgot.requestSubtitle':
    'メールアドレスを入力してください。アカウントが存在する場合は確認コードを送信します。',
  'forgot.sendCode': 'コードを送信',
  'forgot.sendError': '確認コードを送信できませんでした。',
  'forgot.confirmSubtitle': 'メールに記載されたコードを入力し、新しいパスワードを設定してください。',
  'forgot.code': '確認コード',
  'forgot.newPassword': '新しいパスワード',
  'forgot.update': 'パスワードを更新',
  'forgot.updateError': 'パスワードを再設定できませんでした。',
  'forgot.doneSubtitle': 'パスワードを更新しました。ログインできます。',
  'forgot.backToSignIn': 'ログインに戻る',
};
